document.addEventListener('DOMContentLoaded', () => {
  const toggle = document.querySelector('[data-menu-toggle]');
  const nav = document.querySelector('[data-mobile-nav]');
  if (toggle && nav) {
    toggle.addEventListener('click', () => {
      const open = toggle.getAttribute('aria-expanded') === 'true';
      toggle.setAttribute('aria-expanded', String(!open));
      nav.hidden = open;
      document.body.classList.toggle('menu-open', !open);
    });
  }
  document.querySelectorAll('.product-main select[name^="options"]').forEach((select) => {
    select.addEventListener('change', () => {
      const form = select.closest('form');
      const selects = [...form.querySelectorAll('select[name^="options"]')];
      const selected = selects.map((el) => el.value);
      const variants = window.productVariants || [];
      const match = variants.find(v => v.options.every((value, i) => value === selected[i]));
      if (match) {
        const id = form.querySelector('input[name="id"]');
        if (id) id.value = match.id;
        const button = form.querySelector('button[name="add"]');
        if (button) { button.disabled = !match.available; button.textContent = match.available ? 'Add to bag' : 'Sold out'; }
      }
    });
  });
});